import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder, FormArray, ValidatorFn, ValidationErrors } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { FormTemplateDataEntryService } from './../services/form-template-data-entry.service';
import { IDataEntryForm } from './../models/data-entry.model';
import { ZenplansTestDataProviderService } from './../services/zenplans-test-data-provider.service';
import { TextDictionaryService } from './../services/text-dictionary.service';
import { IUrlParameter } from './../models/data-entry.model';
import textList from '../../assets/data/text-dictionary.json';
import countries from '../../assets/data/countries.json';
import { v4 as uuid } from 'uuid';
import { NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { DynamicHelpers } from './../helpers/dynamic-helpers';
import { UserInfoService } from './../services/user-info.service';
import { IUser } from '../models/user.model';

@Component({
  selector: 'dynamic-form-data-entry',
  templateUrl: './dynamic-form-data-entry.component.html',
  styleUrls: ['./dynamic-form-data-entry.component.scss']
})

export class DynamicFormDataEntryComponent implements OnInit, OnDestroy {
  formResult: string = "no results yet";
  myFormGroup: FormGroup = new FormGroup({});
  myFormTemplate: IDataEntryForm;
  templateName;
  Id;
  myItem = {};
  sectionTitle = "";
  showHelp = false;
  myTextList = textList;
  myCountries = countries;
  buttonText = "Next";
  myOptionItem;
  otherFreeText = false;
  message: string;
  showList = false;
  hideList: string[] = [];
  editMode = false;
  dummyShowTrigger: boolean = false;
  //datePicker: NgbDateStruct;
  date: { year: number, month: number };
  submitted = false;
  loggedInUser: IUser;
  // hoveredDate: NgbDate;
  // fromDate: NgbDate;
  // toDate: NgbDate;

  constructor(private activatedRoute: ActivatedRoute, private router: Router,
    private ftService: FormTemplateDataEntryService, private dictService: TextDictionaryService,
    private zenplansTestDataProviderService: ZenplansTestDataProviderService,
    private fb: FormBuilder, private calendar: NgbCalendar,
    private userInfoService: UserInfoService) {
    console.log("start constructor");
    //read paremters sent from form to form
    userInfoService.getMessage().subscribe(user => {
      this.loggedInUser = JSON.parse(user);
    });
    this.activatedRoute.paramMap.subscribe(params => {
      this.templateName = params.get('templateName');
      this.Id = params.get('Id'); //for editting only
      this.getFields();
      console.log("end constructor");
    });
  }

  ngOnChanges() {
    console.log("start onchanges");
    //this.flexableList=[];
  }

  async ngOnInit() {
    console.log("start oninit");
  }

  async getFields() {
    // the appropriate form template from assets
    this.myFormTemplate = await this.ftService.getFormTemplateAsync(this.templateName);
    //An example of a possible implementation to keep all texts in a dictionary. Works but not implemented.
    this.sectionTitle = await this.getText(this.myFormTemplate.sectionTitle);
    //adding fields to group for sending to save
    //otherwise we will add fields based on the template - see below.
    //I don't think we need these two fields when adding a new record
    this.myFormGroup.addControl("clientId", new FormControl(''));
    this.myFormGroup.addControl("Id", new FormControl(''));
    //adding system fields
    this.myFormGroup.addControl("lastUpdate", new FormControl(new Date()));
    this.myFormGroup.addControl("lastUpdateBy", new FormControl(''));
    this.myFormGroup.addControl("upToDateExpire", new FormControl(new Date()));
    //this.myFormGroup.addControl("datePicker", new FormControl(''));
    //Here we add the fields from the template as form objects
    this.myFormTemplate.fields.forEach(async templateObject => {
      //showFields are fields which are toggled by radiobuttonsshow. We keep them in hideList 
      //to make them non-visible on startup.
      if (templateObject.showFields) {
        templateObject.showFields.map(fieldToHide => {
          this.hideList.push(fieldToHide);
        })
      }
      if (templateObject.inputtype.includes("conditionaldropdown")) {
        //adding urls in urlparamters that are fields to the hidelist so they won't show up on init
        templateObject.urlparameters.forEach(element => {
          if (element.urlArray) {
            element.urlArray.forEach(objectHideShow => {
              // let kk = this.myFormTemplate.fields.find(field => {
              //   field.fieldid == url;
              // });
              // if (kk) {
              if (objectHideShow.length > 0) {
                this.hideList.push(objectHideShow);
              }
              //}
            });
          }

        });
        //we need to give the form a kick in order to trigger the hidding/showing of the correct objects
        //this.changeSelection(null, templateObject.urlparameters, localValue);
      }
      if (templateObject.inputtype == "radiobuttons") {
        //adding urls in urlparamters that are fields to the hidelist so they won't show up on init
        templateObject.urlparameters.forEach(element => {
          if (element.urlArray) {
            element.urlArray.forEach(url => {
              // let kk = this.myFormTemplate.fields.find(field => {
              //   field.fieldid == url;
              // });
              // if (kk) {
              if (url.length > 0) {
                this.hideList.push(url);
              }
              //}
            });
          }

        })
      }
      //adding the controls. formarray etc. is for the addable lists.
      //the controls will have fieldIds from the form template. In the html is a scan
      //that use the information in the form templae to fill in texts, decide what object type to use and more
      if (!templateObject.inputtype.includes("formarray")) {
        if (templateObject.validators) {
          var myValidators: ValidatorFn[] = [];
          var validators: [{}] = templateObject.validators;
          templateObject.validators.map(validator => {
            switch (validator["type"]) {
              case "max":
                myValidators.push(Validators.max(validator["value"]));
                break;
              case "min":
                myValidators.push(Validators.min(validator["value"]));
                break;
              case "maxLength":
                myValidators.push(Validators.maxLength(validator["value"]));
                break;
              case "minLength":
                myValidators.push(Validators.minLength(validator["value"]));
                break;
              case "required":
                myValidators.push(Validators.required);
                break;
              case "email":
                myValidators.push(Validators.email);
                break;

            }
          });
          if (templateObject.mandatory && !myValidators.includes(Validators.required)) {
            myValidators.push(Validators.required);
            //This way I can put off adding the validators array to all the templates. And 
            //rely on templateObject.mandatory - which needs to be deleted from the system - TODO
          }
          if (templateObject.inputtype.includes("number")) {
            this.myFormGroup.addControl(templateObject.fieldid, new FormControl(null, Validators.compose(myValidators)));
          }
          else {
            if (templateObject.inputtype.includes("multiselect")) {
              this.myFormGroup.addControl(templateObject.fieldid, new FormControl([]));
            }
            else {
              this.myFormGroup.addControl(templateObject.fieldid, new FormControl('', Validators.compose(myValidators)));
            }
          }
        }
        else {
          if (templateObject.inputtype.includes("number")) {
            this.myFormGroup.addControl(templateObject.fieldid, new FormControl(null, Validators.required));
          }
          else {
            if (templateObject.inputtype.includes("multiselect")) {
              this.myFormGroup.addControl(templateObject.fieldid, new FormControl([], Validators.required));
            }
            else {
              this.myFormGroup.addControl(templateObject.fieldid, new FormControl('', Validators.required));
            }
          }
        }
      }
      else {
        if (templateObject.inputtype.includes("formarray")) {
          if (templateObject.inputtype.includes("columns")) {//formarray of groups
            var myGroup;
            if (templateObject.captions) {
              //TODO - dynamically generate the below  
            }

            switch (templateObject.captions[0]) {
              case "Name":
                {
                  switch (templateObject.captions.length) {
                    case 2:
                      {
                        myGroup = this.fb.group({ Name: "", Email: "" });
                        break;
                      }

                    case 4:
                      {
                        myGroup = this.fb.group({ Name: "", Email: "", Percentage: "", IncomePercentage: "" });
                        break;
                      }
                  }
                  // if (templateObject.captions.length == 2) { //bank accounts
                  //   myGroup = this.fb.group({ Name: "", Email: "" });
                  //   break;
                  // }
                  // else {
                  //   myGroup = this.fb.group({ Name: "", Email: "", Percentage: "", IncomePercentage: "" });
                  //   break;
                  // }
                }
              case "Owner": //mortgages
                {
                  myGroup = this.fb.group({ Owner: "", Email: "", Percentage: "" });
                  break;
                }
              case "Income":
                {
                  myGroup = this.fb.group({ Income: "", Description: "" });
                  break;
                }
              case "Expense":
                {
                  myGroup = this.fb.group({ Expense: "", Description: "" });
                  break;
                }
            }
            this.myFormGroup.addControl(templateObject.fieldid, new FormArray([myGroup]));
          }
          else {
            let myList: string[] = [""];
            this.myFormGroup.addControl(templateObject.fieldid, new FormArray([]));
          }
        }
        else {
          //this.myFormGroup.addControl(templateObject.fieldid, new FormControl(''));
          if (templateObject.inputtype.includes("number")) {
            this.myFormGroup.addControl(templateObject.fieldid, new FormControl(null));
          }
          else {
            if (templateObject.inputtype.includes("multiselect")) {
              this.myFormGroup.addControl(templateObject.fieldid, new FormControl([]));
            }
            else {
              this.myFormGroup.addControl(templateObject.fieldid, new FormControl(''));
            }
          }
        }
      }
      if (templateObject.listSource) {
        templateObject.items = await this.zenplansTestDataProviderService.getSectionItemNames(templateObject.listSource, templateObject.itemType);
      }
    });
    //this.myFormGroup.setValidators(this.emailValidator());//for confirming email
    if (this.myFormTemplate.finishedbuttontext) {
      this.buttonText = this.myFormTemplate.finishedbuttontext;
    }
    //disabling hidden fields so the validation won't check them
    this.hideList.map(objectToDisable => {
      this.myFormGroup.controls[objectToDisable].disable();
    })
  }

  async onSubmit() {
    //dummyShowTrigger is to trigger a *ngIf for hidng and showing fields
    this.dummyShowTrigger = false;
    if (this.myFormGroup.invalid) {
      var kuku = DynamicHelpers.findInvalidControls(this.myFormGroup); //this.findInvalidControls(this.myFormGroup);
      if (kuku && kuku.length > 0) {
        this.submitted = true;
        //alert("The data in the form is not valid.  Please check that all fields have been filled in correctly. " + kuku)
        return;
      }
    }
    if (this.myFormTemplate.finished) {
      //update the data of the item being held in the service
      //clearHiddenFieldValues checks all objects that are not visible at save time and clear's thier data in order to prevent 
      //unwanted data from being saved.
      await this.clearHiddenFieldValues();
      this.myFormGroup.value["Id"] = uuid(); //Guid like key
      this.myFormGroup.value["lastUpdate"] = new Date();
      this.myFormGroup.value["lastUpdateBy"] = "Sam"; //TODO: use logged in user.
      this.myFormGroup.value["upToDateExpire"] = DynamicHelpers.getExpireDate(this.myFormGroup.value["review"]);
      this.myFormGroup.value["clientId"] = this.loggedInUser.Id;
      let pp = JSON.stringify(this.myFormGroup.value)
      //alert(JSON.stringify(pp));
      //This is our local "API". Data is beng stored and called from a JSON stored in application local variable.
      await this.zenplansTestDataProviderService.addItem(pp, this.myFormTemplate.sectionTitle);
      this.goto(this.myFormTemplate.url);
    }
    else {
      this.goto(this.myFormTemplate.url);
    }
  }

  async clearHiddenFieldValues() {
    //we need to use the edit template that has all the fields in the same file.
    //TODO - base the new and edit on the same code and template. Hide and show each step for new
    let template = this.templateName as string;
    template = template.substr(0, template.indexOf("_"));
    let editFormTemplate = await this.ftService.getFormTemplateAsync(template + "-edit");
    DynamicHelpers.clearHiddenFieldValues(editFormTemplate, this.myFormGroup);
  }
  goto(url: string) {
    this.submitted = false;
    this.router.navigate(['/' + url]);
  }

  toggleHelp() {
    if (this.myFormTemplate.help) {
      this.showHelp = !(this.showHelp);
    }
  }

  forkClick(item, dummy) {
    this.myFormTemplate.url = item.url;
  }

  // forkClick(item, elements) {
  //   //Note: to hide/show the fields we would need to use showMe and add remove fields from this.hideList
  //   elements.forEach(element => {
  //     if (element.urlArray) {
  //       // element.url.map(myUrl=>{
  //       //   if((item.url as [''])
  //       // })
  //       element.urlArray.forEach(element2 => {
  //         if ((item.urlArray as ['']).includes(element2)) {
  //           if (this.myFormGroup.controls[element2]) {
  //             this.myFormGroup.controls[element2].enable();
  //             this.manageHideFields("show", [element2]);
  //           }
  //         }
  //         else {
  //           if (this.myFormGroup.controls[element2]) {
  //             this.myFormGroup.controls[element2].disable();
  //             this.manageHideFields("hide", [element2]);
  //           }
  //           // the field will be disabled and not submitted, so we don't need to reset the content. this.myFormGroup.controls[element.url].setValue("");
  //         }
  //       });
  //     }
  //     else //simple enable or disable one field per radio click
  //     {
  //       this.myFormTemplate.url = item.url;
  //       //disable any urlarrays

  //     }
  //   });
  // }

  forkClickYesNo(item) {
    if (item.option == "No") {
      this.goto(item.url);
    }
  }

  showHide(choice, showList) {
    if (choice == "Yes") {
      this.showList = true;
    }
    else {
      this.showList = false;
    }
  }
  showMe(fieldName) {
    if (!this.hideList) { return true; }
    if (this.hideList.length == 0) { return true; }
    if (this.hideList.includes(fieldName)) { return false; }
    else { return true; }
  }

  manageHideFields(choice, showList: string[]) {
    if (choice == "show") {
      showList.map(kk => {
        this.myFormGroup.controls[kk].enable();
        if (this.hideList.includes(kk)) {
          let index = this.hideList.indexOf(kk);
          this.hideList.splice(index, 1);
        }
      })
    }
    else {
      showList.map(kk => {
        this.myFormGroup.controls[kk].disable();
        if (!this.hideList.includes(kk)) {
          this.hideList.push(kk);
          //valadation doesn't check controls that are disabled. 
          //Otherwise if it was required it would throw a validation error
        }
      })
    }
    this.dummyShowTrigger = true;
  }

  onOptionSelected(event) {
    let value = event;
    let selected = value;
    console.log(value);
  }
  changeSelection(event, urls) { //added item? for dynamic edit
    //let selected = event.currentTarget.selectedOptions[0].innerHTML.trim() as string;
    let selected = event.target.value;
    //this.otherFreeText = selected.trim().toLowerCase() === "other";
    //let myUrls = urls.find(kk => kk.option == selected.trim()).urlArray;
    // let urlIsReallyAnotherField = this.myFormTemplate.fields.find(myField => {
    //   myField["fieldid"] == myUrls;
    // });
    var myUrlArray;
    let chosenUrlParameter = urls.find(element =>
      element.option === selected);
    if (chosenUrlParameter.urlArray) {


      urls.forEach(param => {
        if (param.urlArray) {
          // element.url.map(myUrl=>{
          //   if((item.url as [''])
          // })
          param.urlArray.forEach(element2 => {
            if ((chosenUrlParameter.urlArray as ['']).includes(element2)) {
              if (this.myFormGroup.controls[element2]) {
                this.myFormGroup.controls[element2].enable();
                this.manageHideFields("show", [element2]);
              }
            }
            else {
              if (this.myFormGroup.controls[element2]) {
                this.myFormGroup.controls[element2].disable();
                this.manageHideFields("hide", [element2]);
              }
              // the field will be disabled and not submitted, so we don't need to reset the content. this.myFormGroup.controls[element.url].setValue("");
            }
          });
        }
        else //url to another form
        {

          //this.myFormTemplate.url = urls.find(kk => kk.option == selected.trim()).url;
          // //if (param.url[0].length > 0) {
          // if (param.url == chosenUrlParameter.url) {
          //   this.myFormGroup.controls[param.url].enable();
          // }
          // else {
          //   this.myFormGroup.controls[param.url].disable();
          //   // the field will be disabled and not submitted, so we don't need to reset the content. this.myFormGroup.controls[element.url].setValue("");
          // }
          // //}
        }
      });

    }
    else {
      this.myFormTemplate.url = urls.find(kk => kk.option == selected.trim()).url;
    }
  }

  async getText(key: string) {
    let txt = await this.dictService.getText(key); //this.myTextList.find(kk=>kk.key==key).value;
    return txt;
  }

  //see https://www.positronx.io/angular-7-select-dropdown-examples-with-reactive-forms/
  changeItem(e, itemName: string) {
    this.myFormGroup.controls[itemName].setValue(e.target.value, {
      onlySelf: true
    })
  }

  private MatchConfirm(controls: string[]) {

    return (checkForm: FormGroup) => {
      let value1 = checkForm.controls[controls[0]];
      let value2 = checkForm.controls[controls[1]];


      if (value1.value === value2.value) {
        return value2.setErrors(null);
      } else {
        return value2.setErrors({ notEquivalent: true });
      }
    };
  }

  private MatchConfirmed(e, controls: string[]) {
    if (!this.myFormGroup.controls[controls[0]]) { return; }
    if (!this.myFormGroup.controls[controls[1]]) { return; }
    let value1 = this.myFormGroup.controls[controls[0]];
    let value2 = this.myFormGroup.controls[controls[1]];


    if (value1.value === value2.value) {
      value2.setErrors(null);
    } else {
      value2.setErrors({ notEquivalent: true });
      //value2.updateValueAndValidity();
    }

  }

  private emailValidator(): ValidatorFn {
    return (group: FormGroup): ValidationErrors => {
      if (!group.controls['email']) { return; }
      if (!group.controls['emailConfirm']) { return; }
      const email = group.controls['email'];
      const confirmEmail = group.controls['confirmEmail'];
      if (email.value !== confirmEmail.value) {
        confirmEmail.setErrors({ notEquivalent: true });
      } else {
        confirmEmail.setErrors(null);
      }
      return;
    };
  }
  // async getItemNames(section){
  //   return await this.zenplansTestDataProviderService.getSectionItemNames(section);
  // }

  ngOnDestroy() {

  }
}

  // selectToday() {
  //   this.datePicker = this.calendar.getToday();
  // }

  // onDateSelection(date: NgbDate) {
  //   if (!this.fromDate && !this.toDate) {
  //     this.fromDate = date;
  //   } else if (this.fromDate && !this.toDate && date.after(this.fromDate)) {
  //     this.toDate = date;
  //   } else {
  //     this.toDate = null;
  //     this.fromDate = date;
  //   }
  // }

  // isHovered(date: NgbDate) {
  //   return this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate);
  // }

  // isInside(date: NgbDate) {
  //   return date.after(this.fromDate) && date.before(this.toDate);
  // }

  // isRange(date: NgbDate) {
  //   return date.equals(this.fromDate) || date.equals(this.toDate) || this.isInside(date) || this.isHovered(date);
  // }
